import { datadogLogs } from '@datadog/browser-logs';
import { datadogConfig } from '../config/datadog';
import utils from './utils';

const logger = datadogLogs.logger;

export class CommonLogger {
  static init() {
    const isInitialized = datadogLogs.getInitConfiguration() !== undefined;

    if (isInitialized || utils.isLocalHost()) {
      return;
    }

    const env = utils.getEnvironmentName();

    datadogLogs.init({
      clientToken: datadogConfig.DD_CLIENT_TOKEN,
      site: datadogConfig.DD_SITE,
      service: datadogConfig.DD_SERVICE,
      env: env,
      forwardErrorsToLogs: datadogConfig.DD_FORWARD_ERRORS_TO_LOGS,
      sampleRate: datadogConfig.DD_SAMPLE_RATE,
    });
  }

  static debug(message, messageContext) {
    logger.debug(message, messageContext);
  }

  static info(message, messageContext) {
    logger.info(message, messageContext);
  }

  static warn(message, messageContext) {
    logger.warn(message, messageContext);
  }

  static error(message, messageContext) {
    logger.error(message, messageContext);
  }
}
